// extracted by mini-css-extract-plugin
export default {"skinRefine":"SkinRefine_skinRefine__m896a"};